import React, { useContext, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
//third party
import { useSelector, useDispatch } from 'react-redux'
import { changeState } from '../redux/aside'

const Aside = () => {
    const user = useSelector((state) => state.user)
    const dispatch = useDispatch()


    const back_layout = useRef(null)
    const body_layout = useRef(null)
    const navigate = useNavigate()




    const disableScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }



    const handleCloseMenu = (e) => {
        var asideWidth = document.querySelector(".aside-content").clientWidth;
        var body = document.querySelector("body")
        if (e.target.classList.contains('aside-content')) {
        }
        else {
            back_layout.current.style.backgroundColor = "rgba(0, 0, 0, 0)"
            body_layout.current.style.marginRight = `-${asideWidth}px`
            body.style.marginRight = "0px"
            setTimeout(() => {
                dispatch(changeState())
            }, 300)
        }
    }

    useEffect(() => {
        var body = document.querySelector("body")
        setTimeout(() => {
            back_layout.current.style.backgroundColor = "rgba(0, 0, 0, .5)"
            body_layout.current.style.marginRight = "0px"
            body.style.marginRight = "20px"
        }, 1)

    }, [])

    return (
        <aside ref={back_layout} onClick={(e) => handleCloseMenu(e)}>
            <div ref={body_layout} className='aside-content'>
                <Link to={"/"}>
                    <img src={`https://dl.newwebinar.ir/base/logo.png`} alt="" />
                </Link>
                <div className='items'>
                    <Link to={'/journals'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>نشریات دانشگاهی</span>
                    </Link>
                    <Link to={'/contactUs'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>تماس با ما</span>
                    </Link>
                    <Link to={'/webinars'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>دوره های آموزشی</span>
                    </Link>
                    <Link to={'/conferences'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>همایش ها و کنگره ها</span>
                    </Link>
                    <Link to={'/books'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>کتاب ها</span>
                    </Link>
                    <Link to={'/files'}>
                        <i className='	fas fa-angle-left'></i>
                        <span>دوره های آفلاین</span>
                    </Link>


                    {user.value == "" ? (
                        <>
                            <Link to={'/login'}>
                                <i className='	fas fa-angle-left'></i>
                                <span>ورود</span>
                            </Link>
                            <Link to={'/register'}>
                                <i className='	fas fa-angle-left'></i>
                                <span>ثبت نام</span>
                            </Link>
                        </>
                    ) : (

                        <>
                            <Link to={'/dashboard'}>
                                <i className='	fas fa-angle-left'></i>
                                <span>حساب کاربری</span>
                            </Link>
                            <Link to={'/logOut'}>
                                <i className='	fas fa-angle-left'></i>
                                <span>خروج</span>
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </aside>
    )
}

export default Aside